export default __webpack_public_path__ + "static/media/add.bbef6fe8.svg";